import { SupplierState, intitialState } from '../state/supplierstate.state';
import { SupplierStateActions, GET_SUPPLIER_PROFILE_CURRENT_USER_SUCCESS, GET_SUPPLIER_ADDRESS_LIST_BY_CODE_SUCCESS, ADD_SUPPLIER_ADDRESS, GET_TAB_PERMISSIONS_SUCCESS, GET_SUPPLIER_PROFILE_SUCCESS, GET_SUPPLIER_CONTACT_LIST_BY_CODE_SUCCESS,GET_PREVENTATIVE_IN_PROGRESS_SUCCESS, GET_SUPPLIER_ENTITY_LIST_BY_CODE_SUCCESS, ADD_SUPPLIER_CONTACT, EDIT_SUPPLIER_CONTACT, DELETE_SUPPLIER_CONTACT, GET_FIELD_CONFIG_SUCCESS, DELETE_SUPPLIER_ADDRESS, EDIT_SUPPLIER_ADDRESS, CLEAR_SUPPLIER_DETAILS_BY_CODE, ADD_WAREHOUSE_SUPPLIER_ADDRESS, EDIT_WAREHOUSE_SUPPLIER_ADDRESS, DELETE_WAREHOUSE_SUPPLIER_ADDRESS, GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS, GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS, GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE_SUCCESS, GET_SUPPLIER_EXTERNAL_PARTNER_LIST_SUCCESS, GET_VALIDATION_TASK_BY_CODE_SUCCESS, GET_CONTRACTS_BY_CODE_SUCCESS, GET_SUPPLIER_LOCATIONS_BY_CODE_SUCCESS, GET_SUPPLIER_BANK_LIST_BY_CODE_SUCCESS, DELETE_SUPPLIER_BANK, CLEAR_SUPPLIER_BANKS, GET_EMAIL_DOMAINS_SUCCESS, GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS_SUCCESS, GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE_SUCCESS, GET_SUPPLIER_DIVERSITY_BY_CODE_SUCCESS, GET_SUPPLIER_TAX_LIST_BY_CODE_SUCCESS, CLEAR_SUPPLIER_TAXES, DELETE_SUPPLIER_TAX, GET_SUPPLIER_EHS_RESPONSE_BY_CODE_SUCCESS, GET_SUPPLIER_CHANNEL_LIST_BY_CODE_SUCCESS, GET_SUPPLIER_OTP_REQUEST_BY_USER_SUCCESS, GET_SUPPLIER_PENDING_TASKS_CODE_SUCCESS } from '../actions/supplierstate.action';
import { PropertyValue, OPERATION, Permission, SupplierPropertyValue } from 'app/profile/models/supplier.model';
import { Guid } from 'app/shared/utils/utils';

export function SupplierStateReducer(state: SupplierState = intitialState, action: SupplierStateActions): SupplierState {
    switch (action.type) {
        case GET_SUPPLIER_PROFILE_CURRENT_USER_SUCCESS: {
            return {
                ...state,
                currentUser: action.payload
            };
        }

        case GET_SUPPLIER_ADDRESS_LIST_BY_CODE_SUCCESS: {
            if (!state.supplier || !state.supplier.addresses) {
                return {
                    ...state,
                    supplier: {
                        ...state.supplier,
                        addresses: action.payload
                    }
                };
            }
            else {
                return {
                    ...state,
                    supplier: {
                        ...state.supplier,
                        addresses: [
                            ...action.payload,
                            ...state.supplier.addresses
                        ]
                    }
                };
            }
        }

        case GET_SUPPLIER_CONTACT_LIST_BY_CODE_SUCCESS: {
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    contacts: action.payload
                }
            };
        }

        case GET_SUPPLIER_DIVERSITY_BY_CODE_SUCCESS: {
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    diversity: action.payload
                }
            }
        }

        case GET_SUPPLIER_ENTITY_LIST_BY_CODE_SUCCESS: {
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    entities: action.payload
                }
            };
        }

        case GET_EMAIL_DOMAINS_SUCCESS: {
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    domains: action.payload
                }
            };
        }

        case GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE_SUCCESS: {
            if (!state.manufacturingAddresses) {
                return {
                    ...state,
                    manufacturingAddresses: action.payload
                }
            } else {
                return {
                    ...state,
                    manufacturingAddresses: [
                        ...action.payload,
                        ...state.manufacturingAddresses
                    ]
                }
            }
        }

        case ADD_SUPPLIER_ADDRESS: {
            action.payload.operation.newValue = OPERATION.CREATE;
            action.payload.stageID = new PropertyValue<string>();
            action.payload.stageID.newValue = Guid.newGuid();
            action.payload.isTouched = true;
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    addresses: [
                        action.payload,
                        ...state.supplier.addresses
                    ]
                }
            };
        }

        case EDIT_SUPPLIER_ADDRESS: {
            const oldItem: any = action.payload.oldItem;
            const index = state.supplier.addresses.indexOf(oldItem);
            action.payload.data.isTouched = true;
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    addresses: [
                        ...state.supplier.addresses.map((x, i) => {
                            if (i === index) {
                                return action.payload.data;
                            } else {
                                return x;
                            }
                        }),
                    ]
                }
            };
        }

        case DELETE_SUPPLIER_ADDRESS: {
            const index = action.payload;
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    addresses: [
                        ...state.supplier.addresses
                            .map((x, i) => {
                                if (i === index) {
                                    x.isTouched = true;
                                    x.operation.newValue = OPERATION.DELETE;
                                }
                                return x;
                            })
                    ],
                }
            };
        }

        case DELETE_SUPPLIER_BANK: {
            const index = action.payload;
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    banks: [
                        ...state.supplier.banks
                            .map((x, i) => {
                                if (i === index) {
                                    x.isTouched = true;
                                    x.operation.newValue = OPERATION.DELETE;
                                }
                                return x;
                            })
                    ],
                }
            };
        }

        case DELETE_SUPPLIER_TAX: {
            const index = action.payload;
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    taxes: [
                        ...state.supplier.taxes
                            .map((x, i) => {
                                if (i === index) {
                                    x.isTouched = true;
                                    x.operation.newValue = OPERATION.DELETE;
                                }
                                return x;
                            })
                    ],
                }
            };
        }

        case GET_TAB_PERMISSIONS_SUCCESS: {
            return {
                ...state,
                tabPermission: action.payload
            }
        }

        case GET_SUPPLIER_PROFILE_SUCCESS: {
            return {
                ...state,
                supplierProfile: action.payload
            }
        }

        case CLEAR_SUPPLIER_DETAILS_BY_CODE: {
            return {
                ...state,
                supplier: new SupplierPropertyValue(),
                tabPermission: {
                    details: Permission.NoAccess,
                    address: Permission.NoAccess,
                    contact: Permission.NoAccess,
                    bank: Permission.NoAccess,
                    tax: Permission.NoAccess,
                    document: Permission.NoAccess,
                    entity: Permission.NoAccess,
                    status: Permission.NoAccess
                },
                FieldConfiguration: null,
                warehouseAddresses: null,
                validationTask: null,
                contracts: null,
                locations: null,
                manufacturingAddresses: null,
                pickupWarehouseAddresses: null
            }
        }

        case CLEAR_SUPPLIER_BANKS: {
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    banks: null
                }
            };
        }

        case CLEAR_SUPPLIER_TAXES: {
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    taxes: null
                }
            };
        }

        case ADD_SUPPLIER_CONTACT: {
            action.payload.operation.newValue = OPERATION.CREATE;
            action.payload.stageID = new PropertyValue<string>();
            action.payload.stageID.newValue = Guid.newGuid();
            action.payload.isTouched = true;
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    contacts: [
                        action.payload,
                        ...state.supplier.contacts
                    ]
                }
            };
        }

        case EDIT_SUPPLIER_CONTACT: {
            const index: number = action.payload.index;
            action.payload.data.isTouched = true;
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    contacts: [
                        ...state.supplier.contacts.map((x, i) => {
                            if (i === index) {
                                return action.payload.data;
                            } else {
                                return x;
                            }
                        }),
                    ]
                }
            };
        }

        case DELETE_SUPPLIER_CONTACT: {
            const index = action.payload;
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    contacts: [
                        ...state.supplier.contacts
                            .map((x, i) => {
                                if (i === index) {
                                    x.operation.newValue = OPERATION.DELETE;
                                    x.isTouched = true;
                                }
                                return x;
                            })
                    ],
                }
            };
        }

        case GET_SUPPLIER_ENTITY_LIST_BY_CODE_SUCCESS: {
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    entities: action.payload
                },
            };
        }

        case GET_FIELD_CONFIG_SUCCESS: {
            return {
                ...state,
                FieldConfiguration: action.payload
            }
        }

        case ADD_WAREHOUSE_SUPPLIER_ADDRESS: {
            return {
                ...state,
                warehouseAddresses: [
                    action.payload,
                    ...state.warehouseAddresses
                ]
            };
        }

        case EDIT_WAREHOUSE_SUPPLIER_ADDRESS: {
            const index: number = action.payload.index;
            return {
                ...state,
                warehouseAddresses: [
                    ...state.warehouseAddresses.map((x, i) => {
                        if (i === index) {
                            return action.payload.data;
                        } else {
                            return x;
                        }
                    }),
                ]
            };
        }

        case DELETE_WAREHOUSE_SUPPLIER_ADDRESS: {
            const index = action.payload;
            state.warehouseAddresses.splice(index, 1);
            return {
                ...state,
                warehouseAddresses: [
                    ...state.warehouseAddresses
                ]
            };
        }

        case GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS: {
            if (!state.warehouseAddresses) {
                return {
                    ...state,
                    warehouseAddresses: action.payload
                }
            } else {
                return {
                    ...state,
                    warehouseAddresses: [
                        ...action.payload,
                        ...state.warehouseAddresses
                    ]
                }
            }
        }

        case GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS: {
            if (!state.pickupWarehouseAddresses) {
                return {
                    ...state,
                    pickupWarehouseAddresses: action.payload
                }
            } else {
                return {
                    ...state,
                    pickupWarehouseAddresses: [
                        ...action.payload
                    ]
                }
            }
        }

        case GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE_SUCCESS: {
            if (!state.supplier || !state.supplier.documents) {
                return {
                    ...state,
                    supplier: {
                        ...state.supplier,
                        documents: action.payload
                    }
                };
            }
            else {
                return {
                    ...state,
                    supplier: {
                        ...state.supplier,
                        documents: [
                            ...action.payload,
                            ...state.supplier.documents
                        ]
                    }
                };
            }
        }

        case GET_SUPPLIER_EXTERNAL_PARTNER_LIST_SUCCESS: {
            return {
                ...state,
                externalPartnerAddress: action.payload
            }
        }

        case GET_VALIDATION_TASK_BY_CODE_SUCCESS: {
            return {
                ...state,
                validationTask: action.payload
            }
        }

        case GET_CONTRACTS_BY_CODE_SUCCESS: {
            return {
                ...state,
                contracts: action.payload
            }
        }

        case GET_SUPPLIER_LOCATIONS_BY_CODE_SUCCESS: {
            return {
                ...state,
                locations: action.payload
            }
        }

        case GET_SUPPLIER_BANK_LIST_BY_CODE_SUCCESS: {
            if (!state.supplier || !state.supplier.banks) {
                return {
                    ...state,
                    supplier: {
                        ...state.supplier,
                        banks: action.payload
                    }
                };
            }
            else {
                return {
                    ...state,
                    supplier: {
                        ...state.supplier,
                        banks: [
                            ...action.payload,
                            ...state.supplier.banks
                        ]
                    }
                };
            }
        }

        case GET_SUPPLIER_TAX_LIST_BY_CODE_SUCCESS: {
            if (!state.supplier || !state.supplier.taxes) {
                return {
                    ...state,
                    supplier: {
                        ...state.supplier,
                        taxes: action.payload
                    }
                };
            }
            else {
                return {
                    ...state,
                    supplier: {
                        ...state.supplier,
                        taxes: [
                            ...action.payload,
                            ...state.supplier.taxes
                        ]
                    }
                };
            }
        }

        case GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS_SUCCESS:{
            return {
                ...state,
                navigationList: [
                    ...action.payload
                ]
            };
        }

        case GET_SUPPLIER_EHS_RESPONSE_BY_CODE_SUCCESS: {
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    ehsResponse: action.payload
                }
            }
        }

        case GET_SUPPLIER_CHANNEL_LIST_BY_CODE_SUCCESS: {
            return {
                ...state,
                supplier: {
                    ...state.supplier,
                    channels: action.payload
                },
            };
      }

      case GET_SUPPLIER_OTP_REQUEST_BY_USER_SUCCESS: {
        return {
            ...state,
          otpRequest: action.payload
        };
    }

    case GET_SUPPLIER_PENDING_TASKS_CODE_SUCCESS: {
        return{
            ...state,
            userPendingTasks: action.payload
        }
        }
    case GET_PREVENTATIVE_IN_PROGRESS_SUCCESS: {
        return{
            ...state,
            preventativeInProgress: action.payload
        }
    }

        default: return state;
    }

}
